import {
  TButtonTranslations,
} from './npm-controller-menu.ts';

const buttonTranslations: TButtonTranslations = {
  LOAD_JOB: {
    label: 'Load Job',
    confirmMessage: '',
    confirmHeader: '',
    confirmLabel: '',
  },
  START_JOB: {
    label: 'Start Job',
    confirmMessage: 'The job starts right away.',
    confirmHeader: 'Start {recipeCode} on {assetDisplayName}?',
    confirmLabel: 'Start {recipeCode}',
  },
  ABORT_JOB: {
    label: 'Abort Job',
    confirmMessage: 'The running job stops right away.',
    confirmHeader: 'Abort job {jobNo} ({recipeCode}) on {assetDisplayName}?',
    confirmLabel: 'Abort {jobNo}',
  },
  RESUME_JOB: {
    label: 'Resume Job',
    confirmMessage: 'The job continues where it stopped.',
    confirmHeader: 'Resume {recipeCode} on {assetDisplayName}?',
    confirmLabel: 'Resume {recipeCode}',
  },
};

export default {
  button: buttonTranslations,
};
